import { SagaIterator } from "redux-saga";
import { BulkProgrammesFileCheckerRemarkSaga, BulkProgrammesFileMakerRemarkSaga, bulkProgrammesFileType, BulkProgrammesFileVersionSaga, downloadBulkProgrammesFileSaga, fetchBulkProgrammesFileDetailSaga, fetchBulkProgrammesFileSaga, uploadBulkProgrammesFileSaga } from "./types";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { approveBulkProgrammesFileApi, bulkProgrammesFilePublishApi, deleteBulkProgrammesFileApi, downloadBulkProgrammesFileApi, fetchBulkFileSpecificProgrammesApi, fetchBulkProgrammesFileApi, fetchBulkProgrammesFileDetailApi, fetchBulkProgrammesFileVersionApi, rejectBulkProgrammesFileApi, uploadBulkProgrammesFileApi } from "./api";

function* uploadBulkProgrammesFile({ payload, type }: uploadBulkProgrammesFileSaga): SagaIterator {
    try {
        const response = yield call(uploadBulkProgrammesFileApi, payload);

        yield put({
            type: bulkProgrammesFileType.UPLOAD_BULK_PROGRAMMES_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkProgrammesFileType.UPLOAD_BULK_PROGRAMMES_FILE_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkProgrammesFile({ payload, type }: fetchBulkProgrammesFileSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkProgrammesFileApi, payload);

        yield put({
            type: bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_ERROR,
            payload: { error: error }
        });
    }
}


function* DownloadBulkProgrammesFile({ payload, type }: downloadBulkProgrammesFileSaga): SagaIterator {
    try {
        const response = yield call(downloadBulkProgrammesFileApi, payload);
        const fileURL = payload.downloadURL.split("/")
        const responseData = {
            fileBlob: response.data,
            fileName: fileURL[fileURL.length - 1]
        }
        yield put({
            type: bulkProgrammesFileType.BULK_PROGRAMMES_FILE_DOWNLOAD_SUCCESS,
            payload: { data: responseData }
        });
    } catch (error: any) {
        yield put({
            type: bulkProgrammesFileType.BULK_PROGRAMMES_FILE_DOWNLOAD_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkProgrammesFileDetail({ payload, type }: fetchBulkProgrammesFileDetailSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkProgrammesFileDetailApi, payload);
        yield put({
            type: bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_DETAIL_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_DETAIL_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkProgrammesFileVersion({ payload, type }: BulkProgrammesFileVersionSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkProgrammesFileVersionApi, payload);
        yield put({
            type: bulkProgrammesFileType.BULK_PROGRAMMES_FILE_VERSION_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkProgrammesFileType.BULK_PROGRAMMES_FILE_VERSION_ERROR,
            payload: { error: error }
        });
    }
}

function* publishBulkProgrammesFile({ payload, type }: BulkProgrammesFileMakerRemarkSaga): SagaIterator {
    try {
        const response = yield call(bulkProgrammesFilePublishApi, payload);
        yield put({
            type: bulkProgrammesFileType.PUBLISH_BULK_PROGRAMMES_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkProgrammesFileType.PUBLISH_BULK_PROGRAMMES_FILE_ERROR,
            payload: { error: error }
        });
    }
}

function* approveBulkProgrammesFile({ payload, type }: BulkProgrammesFileCheckerRemarkSaga): SagaIterator {
    try {
        const response = yield call(approveBulkProgrammesFileApi, payload);
        yield put({
            type: bulkProgrammesFileType.APPROVE_BULK_PROGRAMMES_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkProgrammesFileType.APPROVE_BULK_PROGRAMMES_FILE_ERROR,
            payload: { error: error }
        });
    }
}

function* rejectBulkProgrammesFile({ payload, type }: BulkProgrammesFileCheckerRemarkSaga): SagaIterator {
    try {
        const response = yield call(rejectBulkProgrammesFileApi, payload);
        yield put({
            type: bulkProgrammesFileType.REJECT_BULK_PROGRAMMES_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkProgrammesFileType.REJECT_BULK_PROGRAMMES_FILE_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkFileSpecificProgrammes({ payload, type }: BulkProgrammesFileVersionSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkFileSpecificProgrammesApi, payload);
        yield put({
            type: bulkProgrammesFileType.FETCH_BULK_FILE_SPECIFIC_PROGRAMMES_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkProgrammesFileType.FETCH_BULK_FILE_SPECIFIC_PROGRAMMES_ERROR,
            payload: { error: error }
        });
    }
}
function* deleteBulkProgrammesFile({ payload, type }: fetchBulkProgrammesFileDetailSaga): SagaIterator {
    try {
        const response = yield call(deleteBulkProgrammesFileApi, payload);
        yield put({
            type: bulkProgrammesFileType.DELETE_BULK_PROGRAMMES_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkProgrammesFileType.DELETE_BULK_PROGRAMMES_FILE_ERROR,
            payload: { error: error }
        });
    }
}

export function* watchUploadBulkProgrammesFile() {
    yield takeEvery(bulkProgrammesFileType.UPLOAD_BULK_PROGRAMMES_FILE, uploadBulkProgrammesFile);
}

export function* watchFetchBulkProgrammesFile() {
    yield takeEvery(bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE, fetchBulkProgrammesFile);
}


export function* watchDownloadBulkProgrammesFile() {
    yield takeEvery(bulkProgrammesFileType.BULK_PROGRAMMES_FILE_DOWNLOAD, DownloadBulkProgrammesFile);
}

export function* watchFetchBulkProgrammesFileDetail() {
    yield takeEvery(bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_DETAIL, fetchBulkProgrammesFileDetail);
}

export function* watchBulkProgrammesFileVersion() {
    yield takeEvery(bulkProgrammesFileType.BULK_PROGRAMMES_FILE_VERSION, fetchBulkProgrammesFileVersion);
}

export function* watchPublishBulkProgrammesFile() {
    yield takeEvery(bulkProgrammesFileType.PUBLISH_BULK_PROGRAMMES_FILE, publishBulkProgrammesFile);
}

export function* watchApproveBulkProgrammesFile() {
    yield takeEvery(bulkProgrammesFileType.APPROVE_BULK_PROGRAMMES_FILE, approveBulkProgrammesFile);
}

export function* watchRejectBulkProgrammesFile() {
    yield takeEvery(bulkProgrammesFileType.REJECT_BULK_PROGRAMMES_FILE, rejectBulkProgrammesFile);
}

export function* watchFetchBulkFileSpecificProgrammes() {
    yield takeEvery(bulkProgrammesFileType.FETCH_BULK_FILE_SPECIFIC_PROGRAMMES, fetchBulkFileSpecificProgrammes);
}

export function* watchDeleteBulkProgrammesFile() {
    yield takeEvery(bulkProgrammesFileType.DELETE_BULK_PROGRAMMES_FILE, deleteBulkProgrammesFile);
}

function* BulkProgrammesFileSaga() {
    yield all([
        fork(watchUploadBulkProgrammesFile),
        fork(watchFetchBulkProgrammesFile),
        fork(watchDownloadBulkProgrammesFile),
        fork(watchFetchBulkProgrammesFileDetail),
        fork(watchBulkProgrammesFileVersion),
        fork(watchPublishBulkProgrammesFile),
        fork(watchApproveBulkProgrammesFile),
        fork(watchRejectBulkProgrammesFile),
        fork(watchFetchBulkFileSpecificProgrammes),
        fork(watchDeleteBulkProgrammesFile)
    ]);
}

export default BulkProgrammesFileSaga;